import errors from './errors/index.js';
import translation from './translation/index.js';
const fa = {
    translation,
    errors,
};
export default Object.freeze(fa);
